import { graphql } from "../gql";

const getHeadToHeadHeaderQuery = graphql(`
  query GetHeadToHeadHeader($input: OddsMarketTypesInput!) {
    event(input: $input) {
      awayTeam {
        record {
          divisionRank
          conferenceRank
          divisionRecord {
            wins
            losses
            ties
            winPercentage
          }
          conferenceRecord {
            wins
            losses
            ties
            winPercentage
          }
          regularSeasonRecord {
            wins
            losses
            ties
            winPercentage
          }
          clinched
        }
      }
      homeTeam {
        record {
          divisionRank
          conferenceRank
          divisionRecord {
            wins
            losses
            ties
            winPercentage
          }
          conferenceRecord {
            wins
            losses
            ties
            winPercentage
          }
          regularSeasonRecord {
            wins
            losses
            ties
            winPercentage
          }
          clinched
        }
      }
      weather {
        condition
        humidity
        tempInF
        windDirection
        windSpeedInMph
      }
      odds {
        moneyline {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          playerStat {
            value
            units
            period
          }
        }
        spread {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        totalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        alternateTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        awayTeamTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        homeTeamTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        totalPointsOddOrEven {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
      }
      oddsResult {
        home {
          spread {
            line
            odds
            success
          }
          moneyline {
            odds
            success
          }
        }
        away {
          moneyline {
            odds
            success
          }
          spread {
            line
            odds
            success
          }
        }
        over {
          line
          odds
          success
        }
        under {
          line
          odds
          success
        }
      }
    }
  }
`);

export default getHeadToHeadHeaderQuery;
